import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Router, Switch, Redirect } from 'react-router-dom';
import { history } from './history';
import { Provider, useDispatch } from 'react-redux';
import { Store } from './store';
import axios from 'axios';
import './i18n';
import Main from './components/Main';
import Login from './components/Login';
import SignUp from './components/SignUp';
import Profile from './components/Profile';
import Config from './components/Config';
import Manual from './components/Manual';
import Releasenotes from './components/Releasenotes';
import AboutCloud from './components/AboutCloud';
import ContactUs from './components/ContactUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermOfUse from './components/TermOfUse';
import App from './components/App';
import Apps from './components/Apps';
import PaypalTest from './components/PaypalTest';

import { AuthAction } from './redux/action';
import { getAuthApiUrl } from './lib/function';


const Setting = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    axios.interceptors.request.use(
      function (config) {
        config.headers["x-ray-deviceuniqueid"] = "WEB";
        config.headers["x-ray-device"] = "RAYLINK";
        return config;
      },
      function (error) {
        return Promise.reject(error);
      });

    axios.interceptors.response.use((response) => response,
      async (error) => {
        const auto_login = localStorage.getItem('AUTO_LOGIN');
        const originalRequest = error.config;
        if (error.response?.status === 404)
          return Promise.reject(error);

        if (error.response?.status === 401 && auto_login === "Y") {
          const refreshToken = localStorage.getItem('MYLAB_AUTH_REFRESHTOKEN');
          const tokenParts = JSON.parse(localStorage.getItem('user'));
          if (refreshToken && tokenParts?.email && tokenParts?.exp) {
            const now = Math.ceil(Date.now() / 1000);
            if (tokenParts.exp < now) {
              const apiUrl = getAuthApiUrl("/refreshtoken");
              return axios.post(apiUrl, {
                refresjtoken: refreshToken,
                email: tokenParts.email
              }).then((response) => {
                const newToken = response.data.data.AuthenticationResult;
                localStorage.setItem('userToken', newToken.IdToken);
                originalRequest.headers['token'] = newToken.IdToken;
                return axios(originalRequest);
              })
                .catch(err => {
                  console.log(err)
                  dispatch(AuthAction.Logout());
                });
            } else {
              console.log("token is unexpired", tokenParts.exp, now);
              dispatch(AuthAction.Logout());
            }
          } else {
            dispatch(AuthAction.Logout());
          }
        } else {
          dispatch(AuthAction.Logout());
        }
        return Promise.reject(error);
      }
    );
  }, [])

  return <></>;
}

ReactDOM.render(
  <Provider store={Store}>
    <BrowserRouter>
      <Router history={history}>
        <Switch>

          <Route path="/download" render={() => <Redirect to="/rayface" />} />
          <Route path="/download/manual/rayface" render={() => <Redirect to="/rayface" />} />
          <Route path="/guide" render={() => <Redirect to="/rayface" />} />

          <Route exact path={"/"} component={Main} />
          <Route exact path={"/login"} component={Login} />
          <Route exact path={"/signup"} component={SignUp} />
          <Route exact path={"/profile"} component={Profile} />
          <Route exact path={"/config"} component={Config} />
          <Route exact path={"/manual"} component={Manual} />
          <Route exact path={"/releasenotes"} component={Releasenotes} />
          <Route exact path={"/aboutcloud"} component={AboutCloud} />
          <Route exact path={"/contact"} component={ContactUs} />
          <Route exact path={"/privacy-policy"} component={PrivacyPolicy} />
          <Route exact path={"/term-of-use"} component={TermOfUse} />
          <Route exact path={"/apps"} component={Apps} />
          <Route exact path={"/abc"} component={PaypalTest} />

          <Route exact path={"/:appCode"} component={App} />
          <Route exact path={"/:appCode/manual"} component={Manual} />
          <Route exact path={"/:appCode/releasenotes"} component={Releasenotes} />
          <Route exact path={"/:appCode/helpcenter"} component={null} />

          
        </Switch>
      </Router>
    </BrowserRouter>
    <Setting />
  </Provider>
  ,
  document.getElementsByClassName("content-wrapper")[0]
);


